module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "content-wrap"
  }, [_c('h1', [_vm._v("Seattle Collisions Visualization Blog")]), _vm._v(" "), _c('div', {
    staticClass: "l-clearfix card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('a', {
    attrs: {
      "href": "https://seattlecollisions.timganter.io/blog/hello-world/"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://seattlecollisions.timganter.io/blog/wp-content/uploads/2017/06/hello_world-150x150-1497327769.gif",
      "alt": "Hello world!",
      "title": "Hello world!"
    }
  })])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "https://seattlecollisions.timganter.io/blog/hello-world/"
    }
  }, [_vm._v("Hello world!")])]), _vm._v(" "), _c('p', [_vm._v("Hello there! I figured I'd start blogging. The response from those that have seen this site has been very positive. I'm glad folks like it and are finding it useful. Seattle Greenways did a blog post on their site and cross posted on The\n                    Urbanist that looks at the cost of traffic violence. And this […]")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ed3c212"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/blog/Blog.vue
// module id = 445
// module chunks = 1